import { Button, Divider, Radio, Carousel, Popconfirm, message, Typography } from 'antd';
import { useState, useEffect } from 'react';
// import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { ArrowsAltOutlined, ReloadOutlined, UpCircleOutlined, DownCircleOutlined, PauseCircleOutlined, PlayCircleOutlined, DeleteOutlined, CopyOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import type { RadioChangeEvent } from 'antd';
import type { ColumnsType, TablePaginationConfig } from 'antd/es/table';

import { DateTime } from 'luxon';

import { Table, Tooltip } from 'antd';
import { Link } from "react-router-dom";
import { Dashboard } from '../types/types';
// import styles from './DashboardList.module.css';
import { PaginatedTable } from './PaginatedTable';
import { SymbolLink } from './SymbolLink';
import { Loading } from './Loading';

import { useAppSelector } from '../app/hooks';
import { selectAccount } from '../features/login/loginSlice';
import { getDashboards, deleteDashboard, editDashboard } from '../services/signalApi';
import { CreateDashboardModal } from '../components/CreateDashboardModal'


interface DashboardListParams {
}


export function DashboardList({}: DashboardListParams) {
    console.log("DashboardList")
    const account = useAppSelector(selectAccount)
    const [reloadedLast, setReloadedLast] = useState('never');
    const [showCreateDashboard, setShowCreateDashboard] = useState(false);
    const [DashboardCopySource, setDashboardCopySource] = useState<Dashboard | null>(null);
    const [dashboardCount, setDashboardCount] = useState<number | null>(null);
    const [reloads, setReloads] = useState(0);
    const createDashboardClick = () => {
        setDashboardCopySource(null)
        setShowCreateDashboard(true)
    }

    const handleCreateCancel = () => {
        setShowCreateDashboard(false)
        setDashboardCopySource(null)
    }

    const handleCreateDashboard = () => {
        // setShowCreateDashboard(false)
        setReloads(reloads + 1)
        // forceUpdate()
    
    }

    const delete_Dashboard = (Dashboard: Dashboard) => {
        console.log("delete_integration", {Dashboard})


        deleteDashboard(Dashboard.id).then((res) => {
            if (res.status === 204 ) {
                const response_data = res.data

            } else if (res.status === 400) {
                const response_data = res.data
            } else {
                console.log("failed", {res})
            }

        }).catch((res) => {

        }).finally(() => {
            setReloads(reloads + 1)

            // dispatch(loadIntegrationsAsync())
        })

    }

    const copy_Dashboard = (Dashboard: Dashboard) => {
        console.log("copy_Dashboard", {Dashboard})
        setDashboardCopySource(Dashboard)
        setShowCreateDashboard(true)
    }


    const content_table = () => {
        let columns: ColumnsType<Dashboard> = [
            {
              title: 'Dashboard',
              dataIndex: 'name',
              key: 'name',
              render: (text: string, row: Dashboard) => {
                return <Link to={`/dashboards/${row.id}/`}>{row.name}</Link>
              },
            },
            {
                title: '',
                key: 'id',
                dataIndex: 'id',
                width: 150,
                // fixed: 'right',
                render: (value: string, row: Dashboard) => (
                    <Space>

                        <Tooltip placement="top" title="Copy">
                                <a onClick={() => copy_Dashboard(row)}>
                                    <CopyOutlined />
                                </a>
                        </Tooltip>

                        <Tooltip placement="top" title="Delete">
                            <Popconfirm title={<Typography.Paragraph>Are you sure you want to remove this Dashboard?</Typography.Paragraph>} okText="Delete" cancelText="Cancel" onConfirm={() => delete_Dashboard(row)}>
                                <a>
                                    <DeleteOutlined />
                                </a>
                            </Popconfirm>
                        </Tooltip>


                        {/* TODO - copy/clone */}
                        {/* TODO - edit name */}

                        {/* <Tooltip placement="top" title="Paused. Click to enable.">
                            <PauseCircleOutlined />
                        </Tooltip> */}

                        {/* clone, delete */}
                    </Space>
  
                )
                // render: (value: string, row: Dashboard) => <a href={`https://www.tradingview.com/chart/?symbol=${row.symbol}`} target='blank'>See on Trading View</a>
                // render: (value: string, row: DataSet) => <a>Subscribe</a>,
            }

        ];
        
        const getPagination = (data: any) => {
            const paginationParams = {
                limit: data.pageSize,
                ...(data.current > 1 ? {offset: (data.current - 1) * data.pageSize} : {}),
                // offset: (data.current - 1) * data.pageSize,
            }
            console.log('DashboardList getPagination', {data, paginationParams})
            return paginationParams
            // return {}
        }

        const fetchData = (data: any) => {
            console.log("DashboardList fetchData", {data})
            const getDashboardsFn = getDashboards;
            return getDashboardsFn({
                ...(data.pagination ? getPagination(data.pagination) : {}),
                ordering: 'name'
            }).then((res) => {
                console.log("DashboardList Dashboards", {res})
                if (res.status === 200) {
                    setDashboardCount(res.data.count || 0)
                    return {
                        results: res.data.results || [],
                        count: res.data.count || 0
                    }
                } else {
                    return {
                        results: [],
                        count: 0
                    }
                }
            }).catch(() => {
                return {
                    results: [],
                    count: 0
                }
            })
        }

        
        console.log("DashboardList Returning...")

        const emptyDescription = () => {
            return "No Dashboards Found"
        }

        return <PaginatedTable<Dashboard>
            columns={columns}
            rowKey={(Dashboard) => Dashboard.id}
            fetchData={fetchData}
            filterValues={{reloadTime: reloadedLast}}
            emptyDescription={emptyDescription()}
            key={reloads}
            size='large'
        />
            
    }

    const head = (
        <Typography.Title level={1}>Dashboards</Typography.Title>
    )

    const triggerReload = () => {
        const dt = DateTime.now();
        setReloadedLast(dt.toISO())
    }

    const newButtonComponent = <Button type="primary" onClick={createDashboardClick} disabled={!!account?.dashboard_cap && !!dashboardCount && account?.dashboard_cap <= dashboardCount}>+ New</Button>

    const newButton = !!account?.dashboard_cap && !!dashboardCount && account?.dashboard_cap <= dashboardCount ?
        <Tooltip title={`At Dashboard Cap of ${account.dashboard_cap}`}>{newButtonComponent}</Tooltip> : newButtonComponent

    const buttons = (
        <Space style={{marginBottom: '6px'}}>
            {/* <Button type="default" onClick={loadDashboards}><ReloadOutlined /></Button> */}
            <Button type="default" onClick={triggerReload}><ReloadOutlined /></Button>
            {newButton}
            {/* <Button type="default">Filter</Button> */}
            {/* <Divider type="vertical" />
            <Radio.Group>
                <Radio.Button value="positive">Positive</Radio.Button>
                <Radio.Button value="neutral">Neutral</Radio.Button>
                <Radio.Button value="negative">Negative</Radio.Button>
            </Radio.Group> */}
            
            {/* <Button type="default">Stocks</Button>
            <Button type="default">Futures</Button>
            <Button type="default">Forex</Button>
            <Button type="default">Crypto</Button>
            <Button type="default">Indices</Button>
            <Button type="default">Bonds</Button>
            <Button type="default">Economy</Button>
            <Button type="default">Other</Button> */}
            {/* <Button type="primary" onClick={clear_click}>Clear</Button> */}
        </Space>
    )

    return (
        <>
            {/* {head} */}
            {buttons}
            {content_table()}
            <CreateDashboardModal
                isOpen={showCreateDashboard}
                onCancel={handleCreateCancel}
                onCreate={handleCreateDashboard}
                dashboardCopySource={DashboardCopySource ? DashboardCopySource : undefined}
            />

        </>
    )
    
    
    
}
